import { createSlice } from "@reduxjs/toolkit";
const DEFAULT_STATE = {
    advancedSettings: true,
    isMinified: true,
    isReact: false,
    exportMode: "js",
    background: "#0d0014",
    schedule: undefined,
    preset: "snow2",
};
const editorSettingsSlice = createSlice({
    name: "editorSettings",
    initialState: DEFAULT_STATE,
    reducers: {
        resetEditorSettings: () => DEFAULT_STATE,
        setEditorSettings: (_state, action) => {
            return action.payload;
        },
        setAdvancedSettings: (state, action) => {
            state.advancedSettings = action.payload;
        },
        setIsMinified: (state, action) => {
            state.isMinified = action.payload;
        },
        setIsReact: (state, action) => {
            state.isReact = action.payload;
            state.exportMode = action.payload ? "jsx" : "js";
        },
        setExportMode: (state, action) => {
            state.exportMode = action.payload;
            state.isReact = action.payload === "jsx" || action.payload === "tsx";
        },
        setBackground: (state, action) => {
            state.background = action.payload;
        },
        setSchedule: (state, action) => {
            state.schedule = action.payload;
        },
        setPreset: (state, action) => {
            state.preset = action.payload;
        },
    },
});
export const { resetEditorSettings, setEditorSettings, setAdvancedSettings, setIsMinified, setIsReact, setExportMode, setBackground, setSchedule, setPreset, } = editorSettingsSlice.actions;
export default editorSettingsSlice.reducer;
